module.exports = __webpack_public_path__ + "96837340b639ff8c165dfbbf748097bc.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/termine/Passepartout.jpg
// module id = 854
// module chunks = 0